import React from 'react'
import { Grid, Typography } from '@mui/material'
import { getContentBlankPage } from '../../util/tools'
import IntlMessages from '../../util/IntlMessages'
import useStyles from './styles'

export default function BlankPage(props) {
    const classes = useStyles()
    let data = getContentBlankPage(props.type)

    return (
        <Grid className={classes.root}>
            <img
                data-testid="img-attribute"
                src={data.image}
                alt={<IntlMessages id="alt.main" />}
                className={classes.image} />
            <Typography
                data-testid="message-attribute"
                variant="h5"
                className={classes.message}>
                {data.message}
            </Typography>
        </Grid>
    )
}
